import React from 'react';
import { connect } from 'react-redux';
import Scenes from '../../../components/scenes/scenes';
import StarList from '../starList/starList';
import ExchangeModal from '../ExchangeModal';
import StarInstruction from '../starInstruction/starInstruction';
import LexueNoticeModal from '../../../components/Modal/LexueNoticeModal';
import common from '../../../common/common';
import { getLexueNotice } from '../../../services/lexueNotice';
import { Commun } from '../../../utils/axios';
import styles from './home.module.scss';
// import { Commun } from '../../../utils/axios';
const LEXUE_NOTICE_KEY = 'star_lexue_notice_done';
class Home extends React.Component {
  homeRef = React.createRef();
  constructor(props) {
    super(props);
    this.state = {
      ScenesShow: true,
      starListShow: false,
      starInstructionShow: false,
      exchangeModalShow: false,
      lexueNoticeVisible: false,
      lexueNotice: null,
    }
    this.hasCheckedLexueNotice = false;
  }
  
  componentDidMount() {
    Commun.get(`${common.userApiPrefix}/simple-info`).then(res => {
      if (!res) return;
      this.props.dispatch({
        type: 'SET_USERINFO',
        payload: {
          userInfo: res,
        },
      });
      this.hasCheckedLexueNotice = false;
      this.showLexueNotice(res);
    }).catch(error => {
      console.log('首页获取用户信息失败', error);
    });
  }

  showDynamic = (target) => {
    this.setState({
      ScenesShow: true,
      starListShow: false,
      starInstructionShow: false,
      exchangeModalShow: false,
      ...target
    })
  }

  closePage = () => {
    // Commun.sendClient('closeStarPage', '');
  }

  showLexueNotice = (userInfo = this.props.userInfo) => {
    const mainOrgId = userInfo?.mainOrgId;
    if (!mainOrgId || this.hasCheckedLexueNotice || !common.isLexue(mainOrgId)) return;
    try {
      if (window.sessionStorage.getItem(LEXUE_NOTICE_KEY)) return;
    } catch (e) {}
    this.hasCheckedLexueNotice = true;
    getLexueNotice().then(res => {
      if (!this.hasNoticeContent(res)) {
        console.log('获取乐学首页公告失败或无有效文案', res);
        return;
      }
      this.openLexueNotice(res);
    }).catch(error => {
      console.log('获取乐学首页公告失败', error);
    });
  };

  hasNoticeContent = (notice) => {
    if (!notice) return false;
    const title = (notice.title || '').trim();
    const content = (notice.content || '').trim();
    return Boolean(title || content);
  };

  openLexueNotice = (notice) => {
    try {
      if (window.sessionStorage.getItem('star_lexue_notice_done')) return;
    } catch (e) {}
    this.setState({
      lexueNoticeVisible: true,
      lexueNotice: notice,
    });
  };

  closeLexueNotice = () => {
    try {
      window.sessionStorage.setItem('star_lexue_notice_done', '1');
    } catch (e) {}
    this.setState({
      lexueNoticeVisible: false,
      lexueNotice: null,
    });
  };


  render() {
    const { ScenesShow, starListShow, exchangeModalShow, starInstructionShow, lexueNoticeVisible, lexueNotice } = this.state;
    return (
      <div className={styles.home} id="home">
        {/* <div className={styles.closePage} onClick={() => this.closePage()}></div> */}
        {ScenesShow && <Scenes showDynamic={this.showDynamic} />}
        {starListShow && <StarList showDynamic={this.showDynamic} />}
        {starInstructionShow && <StarInstruction showDynamic={this.showDynamic} />}
        {/* 星星兑换弹窗 */}
        {
          exchangeModalShow && <ExchangeModal showDynamic={this.showDynamic}/>
        }
        <LexueNoticeModal
          visible={lexueNoticeVisible}
          title={lexueNotice?.title}
          content={lexueNotice?.content}
          onOk={this.closeLexueNotice}
          onCancel={this.closeLexueNotice}
        />
      </div>
    )
  }
}
const mapStateToProps = state => ({
  userInfo: state.common.userInfo,
});

export default connect(mapStateToProps)(Home);
